export const FreemiumWhitelistRoutes = [
    /^\/$/, // utile pour lancer l'application
    /^\/home/, // Accueil
    /^\/lessons\/list\/search\?.*usage=4055.*$/, // Parcours en collectif
    /^\/lessons\/list\/user-lessons$/, // Parcours sur mesure
    /^\/lesson-edition\/editor\/\d+$/, // Éditeur de parcours
    /^\/informations-legales$/, // Informations légales
    /^\/page\/feedback$/, // Contact
    /^\/profile\/show-profile$/, // Profil utilisateur
    /^\/lessons\/\d+\/player.*$/, // lancement de lesson
    /^\/followed\/assignment\/lessons\/\d+\/player.*$/, // lancement de lesson
    /^\/lessons\/\d+\/page\?origin-url=.*$/, // Page detail parcours
    /^\/lessons\/\d+\/page$/, // Page detail parcours
    /^\/lessons\/\d+\/page\?.*$/,// page de details des lessons après avoir quitté le summary
    /^\/lessons\/multi\/player.*$/,
    /^\/page\/site-map(-[\w-]+)?$/,
];